import { OpenInNewOutlined } from "@mui/icons-material";
import styles from "./AiSkillJourney/AISkillJourney.module.css";
import { useState, useEffect } from "react";
import ReactMarkdown from "react-markdown";
import fetchSearchItemsNextToken from "../../graphql/fetchSearchItemsNextToken";
import * as queries from "../../graphql/queries";
import { API } from "aws-amplify";
import remarkGfm from "remark-gfm";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { oneLight } from 'react-syntax-highlighter/dist/esm/styles/prism';

const CodeBlock = ({ language, value }) => {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = async () => {
    await navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div className={styles.codeBlockContainer}>
      <div className={styles.header}>
        <span>{language}</span>
        <button
          onClick={copyToClipboard}
          className={styles.copyBtn}
        >
          {copied ? 'Copied!' : 'Copy'}
        </button>
      </div>
      <SyntaxHighlighter
        language={language}
        style={oneLight}
        customStyle={{
          padding: '16px',
          margin: 0,
          background: '#f6f6f6',
          fontSize: '0.875rem',
          overflowX: 'auto',
        }}
      >
        {value}
      </SyntaxHighlighter>
    </div>
  );
};

const Message = ({
  text,
  setContainerScrollDown,
  recommendations,
  setShowLoader,
}) => {
  const [content, setContent] = useState(text);

  // Moodle Course Direct Enrollment Functions
  const handleTakeCourseClick = async (courseId, sectionLink) => {
    try {
      // console.log("courseId", courseId);
      setShowLoader(true);
      const userEmail = localStorage.getItem("email");
      const userProfileDetailsId = localStorage.getItem("userDetailsID");

      const userProfileDetails = await fetchSearchItemsNextToken({
        query: queries.searchUserProfileDetails,
        variables: { limit: 100, filter: { id: { eq: userProfileDetailsId } } },
      });

      const bodyData = {
        email: userEmail,
        first_name: userProfileDetails[0].first_name,
        last_name: userProfileDetails[0].last_name,
        username: userProfileDetails[0].username,
        courseId: parseInt(courseId),
      };

      // const response = await axios.post(
      //   `https://0oemy34wii.execute-api.ap-south-1.amazonaws.com/enrolment`,
      //   bodyData
      // );

      // For now the Role assigned is non-editing teacher
      const apiName = "moodlecourseenrol";
      const path = "/moodle-enrol";
      const postData = {
        body: {
          email: userEmail,
          first_name: userProfileDetails[0].first_name,
          last_name: userProfileDetails[0].last_name,
          username: userProfileDetails[0].username,
          courseId: parseInt(courseId),
          // courseId: 259, // Just for testing purposes.
        },
      };

      const response = await API.post(apiName, path, postData);
      // console.log("response", response);

      if (response.loginUrl && response.loginUrl !== "") {
        // open the link in a new window
        // console.log("response.loginUrl", response.loginUrl, sectionLink);
        const urlObj = new URL(response.loginUrl);
        const newURL = urlObj.searchParams.set("wantsurl", sectionLink);
        // console.log("newURL", newURL, urlObj.toString());
        window.open(urlObj.toString(), "_blank");
        // window.location.replace(response.loginUrl);
      } else {
        // setShowLoader(false);
      }
    } catch (error) {
      console.error("error", error);
    } finally {
      setShowLoader(false);
    }
  };

  useEffect(() => {
    setContainerScrollDown(Date.now());
  }, [content]);

  return (
    <>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          code({ className, children, ...props }) {
            const match = /language-(\w+)/.exec(className || "");
            const language = match ? match[1] : '';
            const value = String(children).replace(/\n$/, '');
            const isInline = match === null
            return !isInline ? (
            <CodeBlock language={language} value={value} />
          ) : (
            <code className={styles.inlineCodeBlock} {...props}>
              {children}
            </code>
          );
          }
        }}
      >{content}</ReactMarkdown>
      {recommendations && recommendations.length > 0 && (
        <div
          className="recommendations"
          style={{
            borderTop: "1px solid #f1f1f1",
            borderRadius: "5px",
            borderEndEndRadius: "12px",
            padding: "10px",
            marginTop: "10px",
            backgroundColor: "#f9f9f9",
            boxShadow: "inset 0 0 5px 5px #f3f3f3",
          }}
        >
          <h3
            className="recommendation-header"
            style={{
              margin: 0,
              padding: 0,
              fontSize: "0.8rem",
              marginBottom: "10px",
            }}
          >
            Recommendations
          </h3>
          <ul
            style={{
              listStyleType: "none",
              padding: 0,
              margin: 0,
            }}
          >
            {recommendations.map((recommendation, index) => (
              <li
                key={index}
                style={{
                  padding: "10px",
                  borderTop: "1px solid #dedede",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div
                  className="recommendation-box"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <div
                    className="description-wrapper"
                    style={{
                      width: "90%",
                      flex: 1,
                      fontSize: "0.8rem",
                      marginRight: "10px",
                    }}
                  >
                    <div className="recommendation-title">
                      <span style={{ fontWeight: "bold" }}>
                        {recommendation.subject}
                      </span>{" "}
                      : {recommendation.section_name}
                    </div>
                    <div className="recommendation-description">
                      {recommendation.response}
                    </div>
                  </div>
                  <a
                    className="recommendation-icon"
                    // href={`https://devstemclip.mysphere.net/course/view.php?id=${recommendation.course_id}&sectionid=${recommendation.section_id}`}
                    target="_blank"
                    onClick={() =>
                      handleTakeCourseClick(
                        recommendation.course_id,
                        `https://devstemclip.mysphere.net/course/view.php?id=${recommendation.course_id}&sectionid=${recommendation.section_id}`
                      )
                    }
                    style={{
                      textDecoration: "none",
                      color: "teal",
                      width: "10%",
                      height: "100%",
                      display: "flex",
                      justifyContent: "end",
                      alignItems: "center",
                    }}
                  >
                    <OpenInNewOutlined
                      className="recommendation-icon"
                      style={{
                        color: "teal",
                        backgroundColor: "#D9E7E8",
                        borderRadius: "7px",
                        padding: "5px",
                      }}
                    />
                  </a>
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
};

export default Message;
